import { PubSkeletonGrayBox, PubSkeletonWhiteBox } from "../../style/skeleton";
import { PremiumPubInfoBoxWrapper, PremiumPubInfoWrapper } from "./style";

const PremiumPubInfoSkeleton = () => {
  return (
    <PremiumPubInfoWrapper>
      <PremiumPubInfoBoxWrapper>
        <PubSkeletonWhiteBox height="24px" width="111px" />
        <PubSkeletonGrayBox height="126px" radius="8px" />
      </PremiumPubInfoBoxWrapper>
      <PremiumPubInfoBoxWrapper>
        <PubSkeletonWhiteBox height="24px" width="73px" />
        <PubSkeletonGrayBox height="126px" radius="8px" />
      </PremiumPubInfoBoxWrapper>
    </PremiumPubInfoWrapper>
  );
};

export default PremiumPubInfoSkeleton;
